/**
 * The `needs-a-person` label record (spec §1 P-1.2, "Label record"). A handover tags the chat
 * with it whether or not the label exists, but Chatwoot only SHOWS a label it has a record of,
 * and the label filter is the owner's queue. So saving "Hand chats to" makes sure it exists,
 * through Chatwoot's own labels store, as the owner. Best effort: it never fails the save.
 */
import { red } from '@radix-ui/colors';

import { NEEDS_A_PERSON_LABEL } from './chat-ownership.js';

/**
 * Red, from Chatwoot's own palette (the Radix scale `theme/colors.js` is built on). A label
 * stores a hex value, so it cannot be an `n-*` class, and the Waslo tree names no colour
 * literal (the theming contract): the value comes from the palette, not from this file.
 */
export const NEEDS_A_PERSON_COLOR = red.red9;

/** One description, both languages: a label has one, whichever language the viewer reads. */
export const NEEDS_A_PERSON_DESCRIPTION =
  'Handed over by your assistant, not answered yet. / حوّلها المساعد، وما أحد رد للحين.';

export const ensureNeedsAPersonLabel = async store => {
  if (!store) return false;
  try {
    await store.dispatch('labels/get');
    const known = store.getters?.['labels/getLabels'];
    const labels = Array.isArray(known) ? known : [];
    if (
      labels.some(
        label => String(label?.title).toLowerCase() === NEEDS_A_PERSON_LABEL
      )
    ) {
      return true;
    }
    await store.dispatch('labels/create', {
      title: NEEDS_A_PERSON_LABEL,
      description: NEEDS_A_PERSON_DESCRIPTION,
      color: NEEDS_A_PERSON_COLOR,
      show_on_sidebar: true,
    });
    return true;
  } catch {
    return false;
  }
};
